import script from "./ApplicationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationView.vue?vue&type=style&index=0&id=9e093592&scoped=true&lang=css"

import exportComponent from "C:\\wamp64_old\\www\\configurator_vue_new_core_update\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e093592"]])

export default __exports__